// actions/index.js
import { RESET_STORE } from '../types/index';


export const resetStoreState = () => {
    return dispatch => {
      dispatch({ type: RESET_STORE});
    }

  }